module.exports = __webpack_public_path__ + "static/img/img_4.99f04afb.png";